// 安全区变量写在 html 的 style 上（--{ns}-safe-area-*），子代 inherit。
// 组件不包节点。不要改回 display: contents 的空壳，自定义属性过不了 contents。
